import React, { useState } from 'react';
import { LayoutGridIcon, ListIcon } from 'lucide-react';
import { Container, Section } from '../components/ui/Section';
import { PageHeader } from '../components/ui/PageHeader';
import { EventCard } from '../components/events/EventCard';
import { EventList } from '../components/events/EventList';
import { EmptyState } from '../components/ui/EmptyState';
import { ButtonExternal } from '../components/ui/Button';
import { DoodleUnderline } from '../components/brand/Doodles';
import { upcomingEvents } from '../data/events';
import { externalLinks } from '../data/site';
type View = 'cards' | 'list';
const views: {
  id: View;
  label: string;
  icon: typeof ListIcon;
}[] = [{
  id: 'cards',
  label: 'Card view',
  icon: LayoutGridIcon
}, {
  id: 'list',
  label: 'List view',
  icon: ListIcon
}];
export function Events() {
  const [view, setView] = useState<View>('cards');
  return <>
      <PageHeader eyebrow="Events" title="Events at UCF BCM" intro="Worship nights, Welcome Week activities, community events, and opportunities to connect will be posted here as details are confirmed." data-id="element-479" data-mp="1wtobln51gv6q" />

      <Section className="bg-[#fffdf6] py-14 sm:py-18" labelledBy="events-list-heading" data-id="element-480" data-mp="175d32lfp8uea">
        <Container data-id="element-481" data-mp="1m1ue1bjz870b">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-482" data-mp="1m2dwctdjgxev">
            <div data-id="element-483" data-mp="1h4lt537g1ovd">
              <h2 id="events-list-heading" className="font-serif text-2xl font-semibold text-brand-navy sm:text-3xl" data-id="element-484" data-mp="1h1zkt1cqb5c3">
                Confirmed events
              </h2>
              <p className="mt-2 font-meta text-[13px] text-ink" data-id="element-485" data-mp="134b2o1a1qcaq">
                {upcomingEvents.length} entries · updated as details are confirmed
              </p>
            </div>

            <div role="group" aria-label="Choose event layout" className="flex w-fit rounded-full border-2 border-brand-navy bg-white p-1" data-id="element-486" data-mp="ybqa132vm58s">
              {views.map(option => {
              const isActive = view === option.id;
              return <button key={option.id} type="button" aria-pressed={isActive} onClick={() => setView(option.id)} className={`inline-flex min-h-[44px] items-center gap-2 rounded-full px-4 font-meta text-[13px] font-semibold transition-colors ${isActive ? 'bg-brand-navy text-white' : 'text-brand-navy hover:bg-brand-tan'}`} data-id="element-487" data-mp="zempda32a2tb">
                    <option.icon aria-hidden="true" className="h-4 w-4" data-id="element-488" data-mp="ghlitktuzun9" />
                    {option.label}
                  </button>;
            })}
            </div>
          </div>

          <div className="mt-8" data-id="element-489" data-mp="1wu0nt52h9zc4">
            {view === 'cards' ? <ul className="grid gap-5 md:grid-cols-3" data-id="element-490" data-mp="1wts9r9umcnzc">
                {upcomingEvents.map(event => <li key={event.id} className="h-full" data-id="element-491" data-mp="21v7vl44meyis">
                    <EventCard event={event} data-id="element-492" data-mp="3ma4atk1t07ax" />
                  </li>)}
              </ul> : <EventList events={upcomingEvents} data-id="element-493" data-mp="3hckw6j171sig" />}
          </div>

          <div className="mt-8" data-id="element-494" data-mp="3ckb0snhb808s">
            <EmptyState label="More to come" title="Additional events haven’t been entered yet" copy="Community events, retreats, and outreach nights will appear here as soon as BCM leadership confirms the details. Nothing is listed until it is verified." tone="tan" data-id="element-495" data-mp="3cj9nsdgqh3of">
              <ButtonExternal href={externalLinks.instagram} variant="secondary" data-id="element-496" data-mp="2tm8kcx2tvbml">
                Follow @ucfbcm
              </ButtonExternal>
            </EmptyState>
          </div>
        </Container>
      </Section>

      <Section className="bg-brand-blue py-14 sm:py-20" labelledBy="events-cta-heading" data-id="element-497" data-mp="rvdflfqn823q">
        <Container className="max-w-3xl text-center" data-id="element-498" data-mp="mvip3das5ej7">
          <h2 id="events-cta-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-5xl" data-id="element-499" data-mp="mtxvpr07c1mx">
            Want someone to keep you in the loop?
          </h2>
          <DoodleUnderline className="mx-auto mt-3 h-3.5 w-48" color="var(--bcm-pink)" data-id="element-500" data-mp="kzbytbln3a7w" />
          <div className="mt-7 flex justify-center" data-id="element-501" data-mp="px4211rqiire">
            <ButtonExternal href={externalLinks.getConnectedForm} data-id="element-502" data-mp="pvsowbcefynm">Get Connected</ButtonExternal>
          </div>
        </Container>
      </Section>
    </>;
}